"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  featureBlock: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    image: _propTypes["default"].shape({
      image: _propTypes["default"].string,
      altText: _propTypes["default"].string
    }),
    description: _propTypes["default"].string
  })),
  image: _propTypes["default"].shape({
    image: _propTypes["default"].string,
    altText: _propTypes["default"].string
  }),
  link: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    label: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    theme: _propTypes["default"].string,
    openNewTab: _propTypes["default"].bool
  }),
  disclaimerData: _text.disclaimerDataPropTypes
});
var _default = PROP_TYPES;
exports["default"] = _default;